module.exports = __webpack_public_path__ + "img/QRcode.6176d93f.png";